import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import type { House } from '../../types/house';
const PDOK_AERIAL = 'https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/Actueel_orthoHR/EPSG:3857/{z}/{x}/{y}.jpeg';
const ESRI_AERIAL = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';
const NL_CENTER: L.LatLngExpression = [52.2, 5.35];
interface ScanMapProps {
  house: House | null;
}
export function ScanMap({
  house
}: ScanMapProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<L.Map | null>(null);
  const groupRef = useRef<L.LayerGroup | null>(null);
  useEffect(() => {
    const el = containerRef.current;
    if (!el || mapRef.current) return;
    const map = L.map(el, {
      center: NL_CENTER,
      zoom: 8,
      zoomControl: false,
      scrollWheelZoom: false
    });
    L.control.zoom({
      position: 'topright'
    }).addTo(map);
    const pdok = L.tileLayer(PDOK_AERIAL, {
      maxNativeZoom: 19,
      maxZoom: 21,
      attribution: 'Luchtfoto © PDOK'
    });
    let failures = 0;
    let swapped = false;
    pdok.on('tileerror', () => {
      failures += 1;
      if (failures > 4 && !swapped) {
        swapped = true;
        map.removeLayer(pdok);
        L.tileLayer(ESRI_AERIAL, {
          maxNativeZoom: 19,
          maxZoom: 21,
          attribution: 'Imagery © Esri'
        }).addTo(map);
      }
    });
    pdok.addTo(map);
    groupRef.current = L.layerGroup().addTo(map);
    mapRef.current = map;
    const ro = new ResizeObserver(() => map.invalidateSize());
    ro.observe(el);
    return () => {
      ro.disconnect();
      map.remove();
      mapRef.current = null;
      groupRef.current = null;
    };
  }, []);
  useEffect(() => {
    const map = mapRef.current;
    const group = groupRef.current;
    if (!map || !group) return;
    group.clearLayers();
    if (!house) {
      map.setView(NL_CENTER, 8, {
        animate: false
      });
      return;
    }
    const polygon = L.polygon(house.footprint, {
      color: '#D2F36B',
      weight: 3,
      fillColor: '#D2F36B',
      fillOpacity: 0.3
    }).addTo(group);
    L.circleMarker([house.lat, house.lng], {
      radius: 5,
      color: '#0E1B16',
      weight: 2,
      fillColor: '#FFFFFF',
      fillOpacity: 1
    }).addTo(group);
    map.fitBounds(polygon.getBounds(), {
      padding: [90, 90],
      maxZoom: 20,
      animate: false
    });
  }, [house]);
  return <div ref={containerRef} className="h-full w-full" role="img" aria-label="Luchtfoto van de woning" data-id="element-465" data-mp="1m2kbhivvncpn" />;
}